import { ModuleWithProviders, NgModule } from '@angular/core';
import { APP_BASE_HREF, CommonModule, DatePipe, registerLocaleData } from '@angular/common';
import { ActivatedRouteSnapshot } from '@angular/router';
import { MAT_DATE_LOCALE } from '@angular/material/core';
//import { PERFECT_SCROLLBAR_CONFIG, PerfectScrollbarConfigInterface, PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { MatAutocompleteModule } from '@angular/material/autocomplete';

import { HttpEndpointsModule, ServiceHttpModule } from '@ap-angular/service/http';
import { SharedDirectiveModule } from '@ap-angular/shared/directive';
import { PermissionGuard } from '@ap-angular/shared/guard';
import { LOCALIZATION_ID } from '@ap-angular/shared/schema';
import localeRo from '@angular/common/locales/ro';
registerLocaleData(localeRo);
//const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
//	suppressScrollX: true
//};

@NgModule({
	imports: [
		CommonModule,
		//PerfectScrollbarModule,

		SharedDirectiveModule,

		MatAutocompleteModule
	],
	exports: [
		ServiceHttpModule
	],
	providers: [
		{provide: APP_BASE_HREF, useValue: '/'},
		{provide: MAT_DATE_LOCALE, useValue: LOCALIZATION_ID},
		//{provide: PERFECT_SCROLLBAR_CONFIG, useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG},

		ServiceHttpModule,

		DatePipe,
		PermissionGuard,

		{
			provide: 'externalSafeUrl',
			useValue: (route: ActivatedRouteSnapshot) => {
				window.location.href = route.data.externalUrl;
			}
		}
	]
})
export class SharedModule {
	static forRoot(): ModuleWithProviders<SharedModule> {
		return {
			ngModule: SharedModule,
			providers: [ServiceHttpModule, HttpEndpointsModule]
		};
	}
}
